import { Component, Input } from '@angular/core';

@Component({
  selector: 'xe-dot',
  templateUrl: 'xe-dot.html'
})
export class XeDotComponent {
  @Input() value;
  @Input() initialValue;
  @Input() updated;
  @Input() state;
  lastValue;
  lastUpdated;
  rateCss = 'success';
  first: boolean = true;  
  
  constructor() {    
  }

  ngOnChanges() {    
    if (this.state) {
      this.rateCss = this.state;
      return;
    }

    let updated = this.updated;
    if (updated && updated instanceof Date)
      updated = updated.getTime().toString();

    if (this.first) {
      this.lastValue = this.initialValue;
      if (this.lastValue)
        updated = true;
    }
    this.first = false;

    if (this.value > this.lastValue || !updated)
      this.rateCss = 'success';
    else if (this.value < this.lastValue)
      this.rateCss = 'error';
    else if (updated && updated !== this.lastUpdated && this.lastUpdated)
      this.rateCss = 'ok';      

    if (updated) {
      this.lastValue = this.value;
      this.lastUpdated = updated;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/xe-dot/xe-dot.ts